module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fb-Ga-Hc-Ia-Gb.c0b4f7dc.png";